import { render, staticRenderFns } from "./history_courses_card.vue?vue&type=template&id=70e01548&scoped=true&"
import script from "./history_courses_card.vue?vue&type=script&lang=js&"
export * from "./history_courses_card.vue?vue&type=script&lang=js&"
import style0 from "./history_courses_card.vue?vue&type=style&index=0&id=70e01548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e01548",
  null
  
)

export default component.exports